import { StyleSheet } from '@react-pdf/renderer';

const COLORS = {
    ink: '#1a1a1a',
    inkMid: '#4b5563',
    inkMuted: '#6b7280',
    inkLight: '#9ca3af',
    rule: '#e5e7eb'
} as const;

export const ACCENT = {
    amber: '#d97706',
    amberLight: '#fef3c7',
    green: '#15803d'
} as const;

export const dx = StyleSheet.create({
    galleryRow: {
        flexDirection: 'row',
        gap: 12,
        marginTop: 14,
        marginBottom: 4
    },
    galleryImage: {
        flex: 1,
        height: 160,
        borderRadius: 6,
        objectFit: 'cover'
    },

    feeTable: {
        borderWidth: 1,
        borderColor: COLORS.rule,
        borderRadius: 5,
        overflow: 'hidden',
        marginTop: 4
    },
    feeRow: {
        flexDirection: 'row',
        paddingVertical: 9,
        paddingHorizontal: 14,
        borderBottomWidth: 1,
        borderBottomColor: COLORS.rule
    },
    feeLabelCol: {
        flex: 3,
        paddingRight: 10
    },
    feeLabel: {
        fontSize: 11,
        color: COLORS.ink
    },
    feeSubLabel: {
        fontSize: 9,
        color: COLORS.inkMid,
        marginTop: 2
    },
    feeDiscountBlock: {
        marginTop: 3,
        paddingTop: 3,
        borderTopWidth: 0.5,
        borderTopColor: COLORS.rule,
        gap: 1
    },
    feeDiscountLineRow: {
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    feeDiscountRowLabel: {
        fontSize: 8,
        color: COLORS.inkLight
    },
    feeListPrice: {
        fontSize: 8,
        color: COLORS.inkLight,
        textDecoration: 'line-through'
    },
    feeDiscountLabel: {
        fontSize: 8,
        fontWeight: 700,
        color: ACCENT.green
    },
    feeDiscountAmount: {
        fontSize: 8,
        fontWeight: 700,
        color: ACCENT.green
    },
    feeAmount: {
        flex: 1,
        fontSize: 11,
        fontWeight: 700,
        color: COLORS.ink,
        textAlign: 'right'
    },
    feeSubtotalRow: {
        flexDirection: 'row',
        paddingVertical: 10,
        paddingHorizontal: 14,
        borderTopWidth: 1,
        borderTopColor: COLORS.rule
    },
    feeSubtotalLabel: {
        fontSize: 11,
        fontWeight: 700,
        color: COLORS.ink
    },
    feeSubtotalAmount: {
        flex: 1,
        fontSize: 12,
        fontWeight: 700,
        color: COLORS.ink,
        textAlign: 'right'
    },
    feeTotalRow: {
        flexDirection: 'row',
        paddingVertical: 11,
        paddingHorizontal: 14,
        borderTopWidth: 1,
        borderTopColor: COLORS.rule
    },
    feeTotalLabel: {
        flex: 3,
        fontSize: 11,
        fontWeight: 700,
        color: COLORS.ink,
        paddingRight: 10
    },
    feeTotalAmount: {
        flex: 1,
        fontSize: 12,
        fontWeight: 700,
        color: COLORS.ink,
        textAlign: 'right'
    },
    feeNotes: {
        marginTop: 8,
        fontSize: 9,
        color: COLORS.inkMuted,
        fontStyle: 'italic',
        lineHeight: 1.6
    }
});

export { COLORS };
